import { render, staticRenderFns } from "./WebHook.vue?vue&type=template&id=928b8cc2&scoped=true"
import script from "./WebHook.vue?vue&type=script&lang=js"
export * from "./WebHook.vue?vue&type=script&lang=js"
import style0 from "./WebHook.vue?vue&type=style&index=0&id=928b8cc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928b8cc2",
  null
  
)

export default component.exports